import { Clickable } from '@ahmdigital/ui';

import { scrollToElement } from '../ui';

const onClickFootnote = (footnoteId: string) => () => {
  scrollToElement(document.getElementById(footnoteId));
};

const footnoteSerializer =
  (footnoteId: string, variant: any) =>
  ({ node }: { node: { text: string } }) => (
    <Clickable variant={variant} onClick={onClickFootnote(footnoteId)}>
      {node.text}
    </Clickable>
  );

// @ts-expect-error - Automatic, Please fix when editing this file
const getFootnoteSerializer = ({ footnote, variant }) => {
  if (footnote) {
    return { footnote: footnoteSerializer(footnote.linkId, variant) };
  }

  return {};
};

export default getFootnoteSerializer;
